
import { useNavigate } from "react-router-dom";
import MessagePage from "./MessagePage";
import { siteentrylist } from "../../messages/site-entry";
import { personalInformation } from "../../messages/personal-Information";
const { Labels: Lbl_Personal_Info, SuccessMessages: Success_Personal_Info } = personalInformation;
const { Labels: Lbl_SiteEntry, SuccessMessages: Success_SiteEntry, ErrorMessages: Err_SiteEntry} = siteentrylist;

export function UserNotExist() {
  
  const navigate = useNavigate();
  return (
    <MessagePage
      icon="/images/user.png"
      iconAlt="User Icon"
      title={Lbl_SiteEntry.USERNOTEXIST}
      subtitle={
        <>
          {Lbl_SiteEntry.USERNOTEXIST_SUBTITLE1}
          <br />
          {Lbl_SiteEntry.USERNOTEXIST_SUBTITLE2}
        </>
      }
      buttons={[
        { text: Lbl_SiteEntry.USERNOTEXIST_BUTTON1, onClick: () => navigate(`/shokai/touroku`, { state: { from: "sitelogin" } }) },
        { text: Lbl_SiteEntry.USERNOTEXIST_BUTTON2, onClick: () => navigate(`/shokai`) },
      ]}
    />
  );
}
export function UpdateMessage() {
  return (
    <MessagePage
      icon="/images/correct.png"
      iconAlt="Success Icon"
      title={Lbl_Personal_Info.UPDATE_SUCC_TITLE}
      subtitle={Success_Personal_Info.PERSONAL_INFO_UPDATED_MSG}
    />
  );
}
export function RegisterFailed() {
  return (
    <MessagePage
      icon="/images/error.png"
      iconAlt="Error Icon"
      title={Lbl_Personal_Info.REGISTRATION_ERR_TITLE}
      subtitle={Err_SiteEntry.REGISTRATION_ERR}
    />
  );
}
export function RegisterMessage() {
  return (
    <MessagePage
      icon="/images/correct.png"
      iconAlt="Success Icon"
      title={Lbl_Personal_Info.REGISTRATION_SUCC_TITLE}
      subtitle={Success_Personal_Info.PERSONAL_INFO_REGISTERED_MSG}
    />
  );
}
export function EntryTraining() {
  return (
    <MessagePage
      icon="/images/correct.png"
      iconAlt="Success Icon"
      title={Lbl_SiteEntry.NEW_ENTRY_SCREEN}
      subtitle={<span style={{ color: "blue" }}>
        {Success_SiteEntry.TRAINING_SOKUSHIN_MSG}</span>}
    />
  );
}
export function AllDoneSuccess() {
  return (
    <MessagePage
      icon="/images/correct.png"
      iconAlt="Success Icon"
      title={Lbl_SiteEntry.ENTRY_SUCC_MSG}
      subtitle=""
    />
  );
}
export function ExistScreen() {
  return (
    <MessagePage
      icon="/images/correct.png"
      iconAlt="Success Icon"
      title={
        <>
          {Lbl_SiteEntry.EXIT_SUCC_MSG1}
          <br />
          {Lbl_SiteEntry.EXIT_SUCC_MSG2}
        </>
      }
      subtitle=""
    />
  );
}
export function EntryTrainingMessage() {
  return (
    <MessagePage
      icon="/images/correct.png"
      iconAlt="Success Icon"
      title={Lbl_SiteEntry.NEW_ENTRY_REGISTER}
      subtitle={<span style={{ color: "blue" }}>
        {Lbl_SiteEntry.ADDITIONAL_REGISTER_MESSAGE}</span>}
    />
  );
}